import * as Screens from '../screens';

// add NU here

export const menuOptions = {
  Admin: [
    {
      name: 'Looker Dashboards',
      url: '/LookerDashboard',
      deniedGroups: ['Sale', 'Account', 'Creative', 'Compliance', 'NU']
    },
    {
      name: 'UTM Manager',
      url: '/utmManager',
      deniedGroups: ['Sale', 'Account', 'Creative', 'Compliance', 'NU']
    },
    {
      name: 'User Management',
      url: '/userManagement',
      deniedGroups: [
        'Sale',
        'Account',
        'Creative',
        'Campaign',
        'Compliance',
        'NU'
      ]
    }
  ],
  Creation: [
    {
      name: 'Asset Gallery',
      url: '/assetUploader',
      deniedGroups: ['Sale', 'Compliance']
    },
    {
      name: 'Ad Library',
      url: '/adLibrary',
      deniedGroups: ['Sale', 'Creative', 'Compliance']
    },
    {
      name: 'Canvas Tool',
      url: '/canvasTool',
      deniedGroups: ['Sale', 'Compliance']
    },
    {
      name: 'Flipper',
      url: '/presentations/flipperSync#account=&year=&month=',
      deniedGroups: ['Sale', 'Creative', 'Compliance']
    },
    {
      name: 'Organic Scheduler',
      url: '/organicSimplifier#account=&year=&month=',
      deniedGroups: ['Sale', 'Creative', 'Compliance']
    },
    {
      name: 'Package Builder',
      url: '/packageBuilder',
      deniedGroups: ['Sale', 'Creative', 'Compliance']
    },
    {
      name: 'Display Ad Import',
      url: '/adImport',
      deniedGroups: ['Sale', 'Account', 'Creative', 'Compliance', 'NU']
    },
    {
      name: 'Tag Manager',
      url: '/tagManager',
      deniedGroups: ['Sale', 'Compliance', 'NU']
    },
    {
      name: 'UTM Profiles',
      url: '/utmProfiles',
      deniedGroups: ['Sale', 'Compliance', 'NU']
    },
    {
      name: 'Chrome Jellybean Preview',
      url: '/ChromeJelly',
      deniedGroups: ['NU']
    },
    {
      name: 'Lease Special',
      url: '/leaseSpecial',
      deniedGroups: ['Sale', 'Compliance', 'NU']
    }
  ],
  Review: [
    {
      name: 'Ad Preview',
      url: '/preview/list#account=&year=&month=',
      deniedGroups: ['Compliance']
    },
    {
      name: 'Display Ad Preview',
      url: '/adImport/preview',
      deniedGroups: ['Compliance', 'NU']
    },
    {
      name: 'Compliance Workflow',
      url: '/compliance',
      deniedGroups: ['Sale', 'Account', 'Creative', 'Campaign', 'NU']
    }
  ],
  Metrics: [
    {
      name: 'Insights Preview',
      url: '/insightsPreview',
      deniedGroups: ['Creative', 'Compliance', 'NU']
    },
    {
      name: 'Feed API',
      url: '/FeedApi',
      deniedGroups: ['NU']
    }
  ],
  Oversight: [
    {
      name: 'Ad Error Report',
      url: '/adErrorReport#account=&year=&month',
      deniedGroups: ['Sale', 'Creative', 'Compliance', 'NU']
    },
    {
      name: 'QC Summary',
      url: '/QCSummary',
      deniedGroups: ['Sale', 'Creative', 'Compliance', 'NU']
    }
  ],
  Prototypes: [
    {
      name: 'Audience Builder',
      url: '/audienceBuilder',
      deniedGroups: ['Sale', 'Account', 'Creative', 'Compliance', 'NU']
    },
    {
      name: 'Compare Ads',
      url: '/CompareAds',
      deniedGroups: ['Sale', 'Compliance', 'NU']
    }
  ],
  Services: [
    {
      name: 'Organic API',
      url: '/organicApi',
      deniedGroups: ['Sale', 'Account', 'Creative', 'Compliance', 'NU']
    },
    {
      name: 'Screenshot API',
      url: '/screenshotApi',
      deniedGroups: ['Sale', 'Account', 'Creative', 'Compliance', 'NU']
    }
  ],
  Legacy: [
    {
      name: 'Accounts',
      url: '/accounts/list',
      deniedGroups: ['Sale', 'Account', 'Creative', 'Compliance', 'NU']
    },
    {
      name: 'Ad Builder',
      url: '/adBuilder',
      deniedGroups: ['Sale', 'Account', 'Creative', 'Compliance', 'NU']
    },
    {
      name: 'Ad Comparer',
      url: '/adComparer',
      deniedGroups: ['Sale', 'Account', 'Creative', 'Compliance', 'NU']
    },
    {
      name: 'Ad ComparerV2',
      url:
        '/adComparerV2#account=&yearFirst=&monthFirst=&yearSecond=&monthSecond=',
      deniedGroups: ['Creative', 'Compliance', 'NU']
    },
    {
      name: 'Presentations',
      url: '/presentations/list',
      deniedGroups: ['Sale', 'Creative', 'Compliance', 'NU']
    }
  ],
  Share: [
    {
      name: 'Instagram and Facebook',
      url: '/share/instagram',
      deniedGroups: [
        'Sale',
        'Account',
        'Creative',
        'Campaign',
        'Compliance',
        'NU'
      ]
    },
    {
      name: 'Metada Url',
      url: '/share/metadata',
      deniedGroups: [
        'Sale',
        'Account',
        'Creative',
        'Campaign',
        'Compliance',
        'NU'
      ]
    },
    {
      name: 'Template',
      url: '/share/template',
      deniedGroups: [
        'Sale',
        'Account',
        'Creative',
        'Campaign',
        'Compliance',
        'NU'
      ]
    },
    {
      name: 'Settings',
      url: '/share/settings',
      deniedGroups: [
        'Sale',
        'Account',
        'Creative',
        'Campaign',
        'Compliance',
        'NU'
      ]
    }
  ]
};

export const routes = [
  { url: '/', component: Screens.Dashboard, deniedGroups: [], isPrivate: true },
  {
    url: '/presentations/detail/:url',
    component: Screens.PresentationDetail,
    deniedGroups: [],
    isPrivate: false
  },
  {
    url: '/presentationsImport/detail/:url',
    component: Screens.PresentationImportDetail,
    deniedGroups: [],
    isPrivate: false
  },
  {
    url: '/presentations/list',
    component: Screens.PresentationList,
    deniedGroups: ['Sale', 'Creative', 'Compliance'],
    isPrivate: true
  },
  {
    url: '/presentations/flipperSync',
    component: Screens.FlipperSync,
    deniedGroups: ['Sale', 'Creative', 'Compliance'],
    isPrivate: true
  },
  {
    url: '/presentations/flipperSync/updateFields',
    component: Screens.UpdateFlipperAds,
    deniedGroups: ['Sale', 'Creative', 'Compliance'],
    isPrivate: true
  },
  {
    url: '/canvasTool',
    component: Screens.CanvasSearch,
    deniedGroups: ['Sale', 'Compliance'],
    isPrivate: true
  },
  {
    url: '/organicApi',
    component: Screens.OrganicApi,
    deniedGroups: ['Sale', 'Account', 'Creative', 'Compliance', 'NU'],
    isPrivate: true
  },
  {
    url: '/organicSimplifier',
    component: Screens.OrganicSimplifier,
    deniedGroups: ['Sale', 'Creative', 'Compliance'],
    isPrivate: true
  },
  {
    url: '/accounts/list',
    component: Screens.AdAccountList,
    deniedGroups: ['Sale', 'Account', 'Creative', 'Compliance', 'NU'],
    isPrivate: true
  },
  {
    url: '/campaigns/list',
    component: Screens.CampaignList,
    deniedGroups: ['Sale', 'Account', 'Creative', 'Compliance', 'NU'],
    isPrivate: true
  },
  {
    url: '/preview/list',
    component: Screens.PresentationBuilder,
    deniedGroups: ['Compliance'],
    isPrivate: true
  },
  {
    url: '/adComparer',
    component: Screens.AdComparer,
    deniedGroups: ['Sale', 'Account', 'Creative', 'Compliance', 'NU'],
    isPrivate: true
  },
  {
    url: '/adComparerV2',
    component: Screens.AdComparerV2,
    deniedGroups: ['Creative', 'Compliance', 'NU'],
    isPrivate: true
  },
  {
    url: '/adErrorReport',
    component: Screens.AdErrorReport,
    deniedGroups: ['Sale', 'Creative', 'Compliance', 'NU'],
    isPrivate: true
  },
  {
    url: '/accounts/:id',
    component: Screens.AdAccountDetail,
    deniedGroups: ['Sale', 'Account', 'Creative', 'Compliance', 'NU'],
    isPrivate: true
  },
  {
    url: '/campaigns/:id',
    component: Screens.CampaignDetail,
    deniedGroups: ['Sale', 'Account', 'Creative', 'Compliance', 'NU'],
    isPrivate: true
  },
  {
    url: '/adsets/:id',
    component: Screens.AdSetDetail,
    deniedGroups: ['Sale', 'Account', 'Creative', 'Compliance', 'NU'],
    isPrivate: true
  },
  {
    url: '/ad/:id',
    component: Screens.AdDetail,
    deniedGroups: ['Sale', 'Account', 'Creative', 'Compliance', 'NU'],
    isPrivate: true
  },
  {
    url: '/packageBuilder',
    component: Screens.PackageBuilder,
    deniedGroups: ['Sale', 'Creative', 'Compliance'],
    isPrivate: true
  },
  {
    url: '/adLibrary',
    component: Screens.AdLibrary,
    deniedGroups: ['Sale', 'Creative', 'Compliance'],
    isPrivate: true
  },
  {
    url: '/utmProfiles',
    component: Screens.UTMProfiles,
    deniedGroups: ['Sale', 'Compliance', 'NU'],
    isPrivate: true
  },
  {
    url: '/audienceBuilder',
    component: Screens.AudienceBuilder,
    deniedGroups: ['Sale', 'Account', 'Creative', 'Compliance', 'NU'],
    isPrivate: true
  },
  {
    url: '/adBuilder',
    component: Screens.AdBuilder,
    deniedGroups: ['Sale', 'Account', 'Creative', 'Compliance', 'NU'],
    isPrivate: true
  },
  {
    url: '/adImport',
    component: Screens.AdImport,
    deniedGroups: ['Sale', 'Account', 'Creative', 'Compliance', 'NU'],
    isPrivate: true
  },
  {
    url: '/adImport/preview',
    component: Screens.AdImportPreview,
    deniedGroups: ['Compliance', 'NU'],
    isPrivate: true
  },
  {
    url: '/QCSummary',
    component: Screens.QCSummary,
    deniedGroups: ['Sale', 'Creative', 'Compliance', 'NU'],
    isPrivate: true
  },
  {
    url: '/CompareAds',
    component: Screens.CompareAds,
    deniedGroups: ['Sale', 'Compliance', 'NU'],
    isPrivate: true
  },
  {
    url: '/ChromeJelly',
    component: Screens.ChromeData,
    deniedGroups: ['NU'],
    isPrivate: true
  },
  {
    url: '/screenshotApi',
    component: Screens.ScreenshotApi,
    deniedGroups: ['Sale', 'Account', 'Creative', 'Compliance', 'NU'],
    isPrivate: true
  },
  {
    url: '/assetUploader',
    component: Screens.AssetUploader,
    deniedGroups: ['Sale', 'Compliance'],
    isPrivate: true
  },
  {
    url: '/compliance',
    component: Screens.Compliance,
    deniedGroups: ['Sale', 'Account', 'Creative', 'Campaign', 'NU'],
    isPrivate: true
  },
  {
    url: '/insightsPreview',
    component: Screens.InsightsPreview,
    deniedGroups: ['Creative', 'Compliance', 'NU'],
    isPrivate: true
  },
  {
    url: '/insightsPreview/detail/:url',
    component: Screens.InsightsPreviewDetails,
    deniedGroups: ['NU'],
    isPrivate: false
  },
  {
    url: '/share/instagram',
    component: Screens.AdShareInstagram,
    deniedGroups: [],
    isPrivate: true
  },
  {
    url: '/share/metadata',
    component: Screens.AdShareMetadataUrl,
    deniedGroups: ['NU'],
    isPrivate: true
  },
  {
    url: '/share/template',
    component: Screens.AdShareTemplate,
    deniedGroups: ['NU'],
    isPrivate: true
  },
  {
    url: '/share/settings',
    component: Screens.AdShareSettings,
    deniedGroups: ['NU'],
    isPrivate: true
  },
  {
    url: '/userManagement',
    component: Screens.UserSearch,
    deniedGroups: [
      'Sale',
      'Account',
      'Creative',
      'Campaign',
      'Compliance',
      'NU'
    ],
    isPrivate: true
  },
  {
    url: '/utmManager',
    component: Screens.UtmManager,
    deniedGroups: ['Sale', 'Account', 'Creative', 'Compliance', 'NU'],
    isPrivate: true
  },
  {
    url: '/lookerDashboard',
    component: Screens.LookerDashboard,
    deniedGroups: ['Sale', 'Account', 'Creative', 'Compliance', 'NU'],
    isPrivate: true
  },
  {
    url: '/tagManager',
    component: Screens.TagManager,
    deniedGroups: ['Sale', 'Compliance', 'NU'],
    isPrivate: true
  },
  {
    url: '/leaseSpecial',
    component: Screens.LeaseSpecial,

    deniedGroups: ['Sale', 'Compliance', 'NU'],
    isPrivate: true
  },
  {
    url: '/FeedApi',
    component: Screens.FeedApi,
    deniedGroups: ['Sale', 'Compliance', 'NU'],
    isPrivate: true
  }
];



// WEBPACK FOOTER //
// ./src/containers/menuOptions.js